export function generateVideoThumbnail(videoDataUrl) {
  return new Promise((resolve, reject) => {
    const video = document.createElement('video');
    const canvas = document.createElement('canvas');
    const maxWidth = 640;
    const maxHeight = 720;

    video.src = videoDataUrl; // Blob URL or server URL
    video.preload = 'metadata'; 

    video.addEventListener('loadedmetadata', () => {
      // Configure canvas based on video orientation
      if (video.videoWidth >= video.videoHeight) {
        canvas.width = maxWidth;
        canvas.height = (maxWidth * video.videoHeight) / video.videoWidth;
      } else {
        canvas.height = maxHeight;
        canvas.width = (maxHeight * video.videoWidth) / video.videoHeight;
      }
      // Seek to a specific time to ensure a valid frame
      video.currentTime = 0.005;; // 0.005 or 0.1 seconds to avoid blank first frame
    });

    video.addEventListener('seeked', () => {
      // Add a small delay for iOS stability
      setTimeout(() => {
        try {
          const ctx = canvas.getContext('2d');
          ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
          const thumbnailDataUrl = canvas.toDataURL('image/jpeg');
          resolve(thumbnailDataUrl);
        } catch (err) {
          console.error('Error generating thumbnail:', err);
          reject(err);
        } finally {
          // Clean up DOM elements
          video.remove();
          canvas.remove();
        }
      }, 100); // 100ms delay for WebKit stability
    });

    video.addEventListener('error', (e) => {
      video.remove();
      canvas.remove();
      reject(e);
    });
  });
}

export function thumbnailCheckker(url) {
  return new Promise((resolve) => {
    let img = new Image();
    img.onload = () => resolve(true);
    img.onerror = () => resolve(false);
    img.src = url;
  });
}